import { useState, useContext } from 'react';
import { Modal, ModalSection, Dropdown, Button } from '@monash/portal-react';
import c from './feedback-modal.module.scss';
import { RESOLUTION_OPTIONS, UPDATE_FEEDBACK_STATUS } from '../constants';
import { fsUpdateDoc, AuthContext } from '@monash/portal-frontend-common';

const ResolutionModal = ({ open, setResolutionShown, feedbackItem }) => {
  const [selectedResolution, setSelectedResolution] = useState('');
  const authCtx = useContext(AuthContext);

  const closeResolution = () => {
    setResolutionShown(false);
  };

  const submitChanges = () => {
    fsUpdateDoc(`surveyFeedback/${feedbackItem.id}`, {
      status: UPDATE_FEEDBACK_STATUS.RESOLVED,
      reason: selectedResolution,
      history: [
        ...(feedbackItem?.history ?? []),
        {
          time: new Date().getTime(),
          type: 'Closed ticket',
          user: {
            displayName: authCtx.user.displayName,
            email: authCtx.user.email,
          },
        },
      ],
    });

    closeResolution();
  };

  return (
    <Modal open={open} onClose={closeResolution}>
      <ModalSection title="Ticket closure">
        <div className={c.modalAttribute}>
          <h3 className={c.attributeName}>Resolution type:</h3>
          <Dropdown
            placeholder="Select"
            data={RESOLUTION_OPTIONS}
            onChange={(e) => setSelectedResolution(e)}
            value={selectedResolution}
          />
        </div>
        <div className={c.modalButtons}>
          <Button
            variant="text"
            size="medium"
            onClick={() => {
              setSelectedResolution('');
              closeResolution();
            }}
          >
            Discard
          </Button>
          <Button
            size="medium"
            disabled={!selectedResolution}
            onClick={() => {
              submitChanges();
            }}
          >
            Save
          </Button>
        </div>
      </ModalSection>
    </Modal>
  );
};

export default ResolutionModal;
